import { PlanDetailsProps } from '../../superAdmin/pages/ManagePlans/PlanForm';
import { APIS } from '../../utils/apiConfig';
import { HttpService } from '../HttpService/HttpService';

const handleResponse = (response: any) => {
    const { data } = response;

    if (data.sc == 1 || data.statusCode == 200) {
        const { result } = data;
        return result;
    }
};

export class PlanService {
    constructor(private httpService: HttpService) { }

    async getAllPlans(): Promise<any> {
        try {
            const response = await this.httpService.get(APIS.GET_PLAN_INFO(), {
            });
            return handleResponse(response);
        } catch (error) {
            throw error;
        }
    }
    async getPlanByCompany(CompanyName: string): Promise<any> {
        try {
            const response = await this.httpService.post(APIS.GET_PLAN_DETAILS(), {
                CompanyName
            });
            return handleResponse(response);
        } catch (error) {
            throw error;
        }
    }

    async addPlan(payload: PlanDetailsProps): Promise<any> {
        try {
            const response = await this.httpService.post(APIS.ADD_PLAN(), payload);
            return handleResponse(response);
        }
        catch (error) {
            throw error;
        }
    }

    async deletePlan(payload: { featureId: string, planId: string }): Promise<any> {
        const { planId, featureId } = payload;
        try {
            const response = await this.httpService.delete(APIS.DELETE_PLAN(), { planId, featureId });
            return handleResponse(response);
        }
        catch (error) {
            throw error;
        }
    }

    async editPlan(payload: PlanDetailsProps): Promise<any> {
        try {
            const response = await this.httpService.put(APIS.EDIT_PLAN(), payload);
            return handleResponse(response);
        }
        catch (error) {
            throw error;
        }
    }

    async deleteFeature(payload: PlanDetailsProps): Promise<any> {
        try {
            const response = await this.httpService.delete(APIS.DELETE_FEATURE(), payload);
            return handleResponse(response);
        }
        catch (error) {
            throw error;
        }
    }



}
